import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2719b0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "j" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = { class: "detail-item" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, platformOrderItemSettleTypeDict } from './data'
import { isMultiStore } from '@/store'
import { showCurrentUnit } from '@/util/useYan'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowName), 1)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)()&&__props.rowItemDetail?.currencyCode === 'KRW')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('寻源单编号')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderNo), 1)
          ]),
          (__props.rowItemDetail.fundFlowNo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('流水号')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.fundFlowNo), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.createTime ? _unref(getJapanTime)(__props.rowItemDetail?.createTime) : ''), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('商品名称')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)(__props.rowItemDetail?.bizContent)), 1)
        ]),
        _createElementVNode("p", _hoisted_10, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(plusPrice)(__props.rowItemDetail?.changeAmount ?? 0)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)()&&__props.rowItemDetail?.currencyCode === 'KRW')), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})